import { PersonalImageCountType } from '@/App/types';
import { PersonalImageCountStateType } from '@/features/person';

export const getPersonalImageContactsState = (contacts: PersonalImageCountType): PersonalImageCountStateType => {
  const personalImageContacts = {};
  Object.keys(contacts).forEach((key) => {
    personalImageContacts[key] = { contactCount: contacts[key] };
  });
  return personalImageContacts;
};
